import { render, staticRenderFns } from "./IconSvgAMSNHome.vue?vue&type=template&id=256a65ca&scoped=true&"
import script from "./IconSvgAMSNHome.vue?vue&type=script&lang=js&"
export * from "./IconSvgAMSNHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "256a65ca",
  null
  
)

export default component.exports